/** Format the ISO `date` from the API as a Hebrew date, e.g. "8 במאי 2026".
 *  Returns the raw string if it isn't a parseable date. */
export const formatStoryDate = (iso?: string | null): string => {
  if (!iso) return ""
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return iso
  return new Intl.DateTimeFormat("he-IL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(d)
}
